import React from 'react'
import { alpha, Box, Stack, Tooltip, useTheme } from '@mui/material'

/**
 * Priority dots for the integration vote list (VERA-407, ported from Vergence).
 * Five dots filled by tier. We deliberately don't surface raw vote counts to
 * company users (the absolute number leaks user-base size); the dots convey
 * relative rank instead. tier 0 = no votes (5 hollow dots); tier 1..5 =
 * bottom→top priority within the voted subset.
 */
export const PriorityIndicator = ({ tier }: { tier: number }) => {
  const theme = useTheme()
  const safe = Math.max(0, Math.min(5, Math.floor(tier)))
  const label = safe === 0 ? 'No votes yet' : `Popularity: ${safe} of 5`
  return (
    <Tooltip title={label}>
      <Stack direction="row" spacing={0.5} alignItems="center" role="img" aria-label={label}>
        {[1, 2, 3, 4, 5].map((i) => (
          <Box
            key={i}
            sx={{
              width: 9,
              height: 9,
              borderRadius: '50%',
              transition: 'background-color 0.2s',
              // Neutral fill via text.primary (theme-aware: near-white in dark,
              // near-black in light) — reads cleaner than a loud brand accent on
              // what's a secondary popularity signal, and stays visible in BOTH
              // themes (literal white would vanish on the light card). Unfilled dots
              // keep a hollow ring so the indicator reads even at tier 0.
              backgroundColor: i <= safe ? theme.palette.text.primary : 'transparent',
              border: i <= safe ? 'none' : `1.5px solid ${alpha(theme.palette.text.secondary, 0.35)}`,
            }}
          />
        ))}
      </Stack>
    </Tooltip>
  )
}
